import { all } from 'redux-saga/effects';

import confrontarDigitais from './confrontarDigitais/saga';
import consultarTemporalidade from './consultarTemporalidade/saga';

export default all([confrontarDigitais, consultarTemporalidade]);
